<template>
<div>
  <v-container fluid grid-list-md>
    <v-progress-linear v-if="loading" :indeterminate="true">
    </v-progress-linear>

    <div v-else>
      <NewValue v-on:created="createdValue($event)" :schema="relatedSchemas"></NewValue>
      <Search v-on:sort="sort($event)" v-on:search="search($event)" />
      <v-data-iterator :items="items" :rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination" content-tag="v-layout" row wrap>
        <template v-slot:item="props">
          <v-flex xs12 sm6 md4 lg3>
            <RelatedValueView v-on:update="updateValue($event)" v-on:delete="deleteValue($event)" :deleteEnabled="true" :relatedValue="props.item" :relatedSchema="relatedSchemas" />
          </v-flex>
        </template>
      </v-data-iterator>
    </div>
  </v-container>
</div>
</template>
<script>
import NewValue from "./value/NewValue"
import Search from "@/components/common/SearchSort"
import RelatedValueView from "./value/ValueCard"
import http from '@/plugins/http'

export default {
  components: {
    NewValue,
    RelatedValueView,
    Search
  },
  data() {
    return {
      name: "",
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 4
      },
      items: [],
      allItems: [],
      relatedSchemas: {},
      loading: true
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {
    let schema = http.get("related/schema/" + this.$route.params.schemaId)
    let values = http.get("related/schema/" + this.$route.params.schemaId + "/values")

    Promise.all([schema, values]).then(data => {
      this.relatedSchemas = data[0].data
      this.relatedSchemas.keys = this.relatedSchemas.keys != null ?
        this.relatedSchemas.keys.sort(((i1, i2) => i2.order < i1.order)) : this.relatedSchemas.keys

      this.items = data[1].data.map(item => this.mapAndSortItemOrders(item))
      this.allItems = data[1].data.map(item => this.mapAndSortItemOrders(item))

    }).finally(() => this.loading = false)
  },
  methods: {
    sort(event) {
      this.items = this.sortItems(this.items, event.sort)
    },
    sortItems(items, method) {
      if (method == "" || method == undefined) {
        return items
      }
      items.sort((a, b) => a.code.localeCompare(b.code))

      if (method == "DESC") {
        items.reverse()
      }

      return items
    },
    mapAndSortItemOrders(value) {
      if (value && value.values != null) {
        value.values = value.values.sort((v1, v2) => v2.order < v1.order)
      }
      return value
    },
    search(event) {
      let phrase = event.search

      if (phrase == "") {
        this.items = this.sortItems(this.allItems, event.sort)
        return
      }

      let matchItems = []
      let regex = new RegExp('.*(' + phrase + ').*', "i");
      this.allItems.forEach(item => {
        if (regex.test(item.code) || regex.test(item.name)) {
          matchItems.push(item)
          return
        }

        if (!item.values) {
          return
        }

        item.values.forEach(valueObj => {
          if (regex.test(valueObj.value)) {
            matchItems.push(item)
            return
          }
        })
      })

      this.items = this.sortItems(matchItems, event.sort)
    },
    deleteValue(value) {
      http.delete("related/schema/" + this.relatedSchemas.id + "/values/" + value.id).then(() => {
        this.items = this.items.filter(val => val.id != value.id)
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: "Error",
          color: "danger",
        })
      })
    },
    createdValue(value) {
      this.items.push(value)
    },
    updateValue(event) {
      http.put("related/schema/" + this.relatedSchemas.id + "/values/" + event.model.id, event.model).then(() => {
        this.items = this.items.map(v => v.id != event.model.id ? v : event.model)
        event.callback()
        this.$store.commit("setSnack", {
          message: "Zaktualizowano",
          color: "success",
        })

      }).catch(() => {
        this.$store.commit("setSnack", {
          message: "Bład podczas aktualizacji",
          color: "danger",
        })
      })
    }
  },
}
</script>

<style>

</style>
